import "./section-header.scss";

import React from "react";
import classNames from "classnames";

const SectionHeader = ({ title, subtitle, reversed = false, variant }) => {
  return (
    <div
      className={classNames("section-header", {
        [`section-header--reversed`]: reversed === true,
      })}
    >
      <h2
        className={classNames("section-header__title", {
          [`section-header__title--big`]: variant === "singleBig",
        })}
      >
        {title}
      </h2>
      <h3 className="section-header__subtitle">{subtitle}</h3>
    </div>
  );
};

export default SectionHeader;
